
<template>
    <veui-dialog
        theme="ai"
        :open="open"
        overlay-class="offline-pay-dialog"
        @cancel="handleClose"
    >
        <div class="offline-pay-dialog-content">
            <span class="pagination-icon" @click="handlePrev">
                <veui-icon
                    v-if="productCount > 4"
                    name="chevron-left"
                />
            </span>
            <div class="offline-pay-dialog-card-content">
                <offline-pay-card
                    v-for="(item,index) in productList"
                    :key="item.key"
                    :data="item"
                    :style="getCardItemStyle(index)"
                />
            </div>
            <span class="pagination-icon" @click="handleNext">
                <veui-icon
                    v-if="productCount > 4"
                    name="chevron-right"
                />
            </span>
        </div>
        <template #foot>
            <div
                class="ok-btn"
                @click="handleOk"
            >
                立即查看
            </div>

        </template>
    </veui-dialog>
</template>

<script>
import {Dialog, Icon} from 'veui';
import OfflinePayCard from './OfflinePayCard';
import {nanoid} from 'nanoid';
import 'veui-theme-dls-icons/chevron-right';
import 'veui-theme-dls-icons/chevron-left';
const PAGE_SIZE = 4;
export default {
    inject: ['alsLog'],
    components: {
        'veui-dialog': Dialog,
        'veui-icon': Icon,
        OfflinePayCard
    },
    props: {
        open: {
            type: Boolean,
            default: false
        },
        data: {
            type: Object,
            default: () => ({})
        }
    },
    data() {
        return {
            current: 1
        };
    },
    computed: {
        productList() {
            try {
                const res =  JSON.parse(this.data.jsonContent);
                return res.items.map(i => {
                    return {
                        ...i,
                        key: nanoid()
                    };
                });
            }
            catch (err) {
                return [];
            }
        },
        productCount() {
            return this.productList.length;
        }
    },
    methods: {
        async handleClose() {
            this.$emit('update:open', false);
        },
        handleOk() {
            this.handleClose();
            this.alsLog({
                f1: 'couponEnter',
                f2: 'click',
                f11: 'payOffDialog'
            });
            this.$router.push({
                name: 'couponManage'
            });
        },
        handlePrev() {
            if (this.current === 1) {
                return;
            }
            this.current--;
        },
        handleNext() {
            if (this.current >= this.productCount) {
                return;
            }
            this.current++;
        },
        getCardItemStyle(index) {
            const min = (this.current - 1) * PAGE_SIZE;
            const max = this.current * PAGE_SIZE - 1;
            const isShow = index >= min && index <= max;

            return {
                display: isShow ? 'flex' : 'none'
            };
        }
    },
    mounted() {
    }
};
</script>

<style lang="less" scoped>
.offline-pay-dialog {
    /deep/ .veui-ai-dialog-content {
        width: 624px;
        height: 478px;
        box-shadow: none;
        background-color: transparent;
        background-image: url("https://qiaojiang.bj.bcebos.com/fe/static/images/messageCardBg_Buy.png");
        background-size: contain;
        background-repeat: no-repeat;
        background-position: center;
    }
    /deep/ .veui-ai-dialog-content-head {
        height: 145px;
        padding: 45px 95px 12px 95px;
        &-close {
            color: #A56D00;
            &:hover {
                color: #A56D00;
            }

        }
    }
    /deep/ .veui-ai-dialog-content-body {
        padding: 0 36px;
    }
    &-content {
        height: 100%;
        display: flex;
        gap: 2px;
        justify-content: center;
        align-items: center;
    }
    .pagination-icon {
        display: inline-block;
        height: 18px;
        font-size: 18px;
        cursor: pointer;
        color: #A56D00;
    }
    .offline-pay-dialog-card-content {
        flex: 1;
        display: flex;
        gap: 16px;
        justify-content: center;
        align-items: center;
        /deep/ .offline-pay-card {
            flex-shrink: 0;
        }
    }

    /deep/ .veui-ai-dialog-content-foot {
        height: 120px;
        padding-top: 12px;
        padding-bottom: 60px;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .ok-btn {
        width: 168px;
        height: 48px;
        border-radius: 26px;
        display: flex;
        justify-content: center;
        align-items: center;
        background: linear-gradient(92.43deg, #ECCD74 0%, #FDE6BA 51.23%, #E9AF46 100%);
        box-shadow: inset 0px 1px 4px rgba(255, 255, 255, 0.6);
        border: 1px solid;
        border-image-source: linear-gradient(180deg, #FFFBF1 0%, rgba(255, 255, 255, 0.5) 100%);

        font-family: 'PingFang SC';
        font-weight: 500;
        font-size: 18px;
        line-height: 26px;
        color: #664300;
        cursor: pointer;
    }

}
</style>
